export const MOBILE_WIDTH = 575;


// WEBPACK FOOTER //
// ./src/constants/viewport.constants.js